/** @jsx jsx */
import { jsx } from '@emotion/core';
import { FC, useMemo } from 'react';
import { FormControlLabel, Box } from '@material-ui/core';
import Checkbox from 'components/Checkbox';
import { useMarkdownMultilineTranslate } from 'hooks/useTranslate/useTranslate';
import { Field, FieldProps } from 'formik';
import styles from './styles';

import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import useFeature from 'hooks/useFeature';

const StudentApplication: FC = () => {
  const tMdMultiline = useMarkdownMultilineTranslate();
  const { isEnabled } = useFeature();
  const enabled = useMemo(() => isEnabled('studentApplication'), [isEnabled]);
  return enabled ? (
    <Box css={styles.container}>
      <div css={styles.studentApplicationText}>
        {tMdMultiline('studentApplication.content')}
      </div>
      <Field name="studentApplication" type="checkbox">
        {(fieldProps: FieldProps) => (
          <FormControlLabel
            id="creditAppStudentApplication"
            labelPlacement={'end'}
            css={styles.studentApplicationLabel}
            control={
              <Checkbox
                {...fieldProps.field}
                value={Boolean(fieldProps.field.value)}
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                color="primary"
              />
            }
            label={tMdMultiline('studentApplication.label')}
          />
        )}
      </Field>
    </Box>
  ) : null;
};

export default StudentApplication;
